<template>
  <div class="minuta page-break-inside-avoid">
    <div class="block-1-2">
      <div class="column brd-tl">
        <img src="../../../../images/shipping-companies/latamcargopb.png">
      </div>
      <div class="column">
        <div class="row row-1 large-block">
          <div class="center brd-tl brd-r">
            <span class="center">MINUTA DE DESPACHO</span>
            <div>
              <canvas class="barcode"
                :data-text="minuta_code"
                :data-value="minuta_code_value"
                data-width="2"
                data-height="40"
                data-margin="0"
                data-font="arial"
                data-font-size="5"
                data-textposition="top">
              </canvas>
            </div>
          </div>
        </div>
        <div class="row row-2 medium-block">
          <div class="brd-tl">
            <span class="field-span small-span">Tipo de Emissão</span>
            <span class="field-selector">Normal</span>
          </div>
          <div class="brd-tl brd-r">
            <span class="field-span small-span">Tipo de Serviço</span>
            <span class="field-selector">{{ order.service.name | upper }}</span>
          </div>
        </div>
        <div class="row row-3 medium-block">
          <div class="brd-tl">
            <span class="field-span small-span">Coleta Domicílio </span>
            <span class="field-selector">{{`[${order.collect ? ' ' : 'X'}] NAO [${order.collect ? 'X' : ' '}] SIM`}}</span>
          </div>
          <div class="brd-tl">
            <span class="field-span small-span">Entrega Domicílio</span>
            <span class="field-selector">[ ] NAO [X] SIM</span>
          </div>
          <div class="brd-tl brd-r">
            <span class="field-span small-span">Pagamento Destino</span>
            <span class="field-selector">[X] NAO [ ] SIM</span>
          </div>
        </div>
      </div>
    </div>
    <div class="block-2">
      <div class="row">
        <div class="small-block brd-tl brd-b">
          <span class="field-span small-span">Origem</span>
          <span class="field-selector">{{ origin.airport | upper }} - {{ origin.city | upper }}</span>
        </div>
      </div>
      <div class="row">
        <div class="small-block brd-all">
          <span class="field-span small-span">Destino</span>
          <span class="field-selector">{{ destiny.airport | upper }} - {{ destiny.city | upper }}</span>
        </div>
      </div>
    </div>

    <span class="subtitle">Remetente</span>
    <div class="block-1">
      <div class="row row-2-1">
        <div class="brd-tl">
          <span class="field-span">Nome / Razão Social</span>
          <span class="field-span">{{ order.from.name | upper }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">CNPJ / CPF</span>
          <span class="field-span">{{ order.from.company_document || order.from.document }}</span>
        </div>
      </div>
      <div class="row row-2-1-1">
        <div class="brd-tl">
          <span class="field-span">E-mail</span>
          <span class="field-span">{{ order.from.email | upper }}</span>
        </div>
        <div class="brd-tl">
          <span class="field-span">Telefone</span>
          <span class="field-span">{{ order.from.phone }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">IE</span>
          <span class="field-span">{{ order.from.state_register || 'ISENTO' }}</span>
        </div>
      </div>
      <div class="row row-1">
        <div class="brd-tl brd-r">
          <span class="field-span">Endereço</span>
          <span class="field-span">{{ order.from.address | upper }}, {{ order.from.location_number | upper }}</span>
        </div>
      </div>
      <div class="row row-2-1">
        <div class="brd-tl">
          <span class="field-span">Complement</span>
          <span class="field-span">{{ order.from.complement | upper }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">CEP</span>
          <span class="field-span">{{ order.from.postal_code | upper }}</span>
        </div>
      </div>
      <div class="row row-2">
        <div class="brd-tl brd-b">
          <span class="field-span">Bairro</span>
          <span class="field-span">{{ order.from.district | upper }}</span>
        </div>
        <div class="brd-all">
          <span class="field-span">Cidade - UF</span>
          <span class="field-span">{{ order.from.city | upper }} - {{ order.from.state_abbr | upper }}</span>
        </div>
      </div>
    </div>

    <span class="subtitle">Destinatário</span>
    <div class="block-1">
      <div class="row row-2-1">
        <div class="brd-tl">
          <span class="field-span">Nome / Razão Social</span>
          <span class="field-span">{{ order.to.name | upper }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">CNPJ / CPF</span>
          <span class="field-span">{{ order.to.company_document || order.to.document }}</span>
        </div>
      </div>
      <div class="row row-2-1-1">
        <div class="brd-tl">
          <span class="field-span">E-mail</span>
          <span class="field-span">{{ order.to.email | upper }}</span>
        </div>
        <div class="brd-tl">
          <span class="field-span">Telefone</span>
          <span class="field-span">{{ order.to.phone }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">IE</span>
          <span class="field-span">{{ order.to.state_register || 'ISENTO' }}</span>
        </div>
      </div>
      <div class="row row-1">
        <div class="brd-tl brd-r">
          <span class="field-span">Endereço</span>
          <span class="field-span">{{ order.to.address | upper }}, {{ order.to.location_number | upper }}</span>
        </div>
      </div>
      <div class="row row-2-1">
        <div class="brd-tl">
          <span class="field-span">Complement</span>
          <span class="field-span">{{ order.to.complement | upper }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">CEP</span>
          <span class="field-span">{{ order.to.postal_code | upper }}</span>
        </div>
      </div>
      <div class="row row-2">
        <div class="brd-tl brd-b">
          <span class="field-span">Bairro</span>
          <span class="field-span">{{ order.to.district | upper }}</span>
        </div>
        <div class="brd-all">
          <span class="field-span">Cidade - UF</span>
          <span class="field-span">{{ order.to.city | upper }} - {{ order.to.state_abbr | upper }}</span>
        </div>
      </div>
    </div>

    <span class="subtitle">Tomador</span>
    <div class="block-1">
      <div class="row row-2-1">
        <div class="brd-tl">
          <span class="field-span">Nome / Razão Social</span>
          <span class="field-span">{{ $options.static.name }}</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">CNPJ / CPF</span>
          <span class="field-span">{{ $options.static.cnpj }}</span>
        </div>
      </div>
      <div class="row row-2-1-1">
        <div class="brd-tl">
          <span class="field-span">E-mail</span>
          <span class="field-span">LATAM@MELHORENVIO.COM.BR</span>
        </div>
        <div class="brd-tl">
          <span class="field-span">Telefone</span>
          <span class="field-span">5341412888</span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">IE</span>
          <span class="field-span">ISENTO</span>
        </div>
      </div>
      <div class="row row-1">
        <div class="brd-tl brd-r">
          <span class="field-span">Endereço</span>
          <span class="field-span">AVENIDA REPÚBLICA DO LÍBANO, 849</span>
        </div>
      </div>
      <div class="row row-2-1">
        <div class="brd-tl">
          <span class="field-span">Complemento</span>
          <span class="field-span"></span>
        </div>
        <div class="brd-tl brd-r">
          <span class="field-span">CEP</span>
          <span class="field-span">96055710</span>
        </div>
      </div>
      <div class="row row-2">
        <div class="brd-tl brd-b">
          <span class="field-span">Bairro</span>
          <span class="field-span">TRÊS VENDAS</span>
        </div>
        <div class="brd-all">
          <span class="field-span">Cidade - UF</span>
          <span class="field-span">PELOTAS - RS</span>
        </div>
      </div>
    </div>

    <div class="block-1 mt-16">
      <div class="row row-1">
        <div class="small-block brd-tl brd-r">
          <span class="field-span">INFORMAÇÕES DA CARGA</span>
        </div>
      </div>
      <div class="row row-3 brd-tl brd-r">
        <div>
          <span class="field-span">Tipo de carga</span>
          <span class="field-span">CARGA GERAL</span>
        </div>
        <div>
          <span class="field-span">Valor</span>
          <span class="field-span">{{ order.insurance_value | currency }}</span>
        </div>
        <div>
          <span class="field-span">Tipo de Seguro</span>
          <span class="field-span">Seguro TAM</span>
        </div>
      </div>
      <div class="row row-2 brd-all">
        <div>
          <span class="field-span">Seguradora</span>
          <span class="field-span">LATAM</span>
        </div>
        <div>
          <span class="field-span">Num.</span>
        </div>
      </div>
    </div>

    <span class="field-span">VOLUMES</span>
    <div class="block-1 mt-16">
      <div class="row row-3-1-1-2 mb-8">
        <div class="no-border">
          <span class="field-span">Tipo de Embalagem</span>
        </div>
        <div class="no-border">
          <span class="field-span">Quantidade</span>
        </div>
        <div class="no-border">
          <span class="field-span">Peso</span>
        </div>
        <div class="no-border">
          <span class="field-span">Comp x Larg x Alt ( CM )</span>
        </div>
      </div>
      <div class="row row-3-1-1-2 mb-8" :key="index" v-for="(volume,index) in groupVolumes">
        <div class="small-block brd-tl brd-b">
          <span class="field-span">DIVERSOS</span>
        </div>
        <div class="small-block brd-tl brd-b">
          <span class="field-span">{{volume.times}}</span>
        </div>
        <div class="small-block brd-tl brd-b">
          <span class="field-span"> {{ volume.weight }}</span>
        </div>
        <div class="small-block brd-all">
          <span class="field-span">{{ volume.length }} X {{ volume.width }} X {{ volume.height }}<br></span>
        </div>
      </div>
      <div class="row row-3-2">
        <div class="small-block brd-tl brd-b">
          <span class="field-span">Tipo de Documento:
            <template v-if="order.invoice && order.invoice.key">NFE</template>
            <template v-else>DECLARACAO VALOR</template>
          </span>
        </div>
        <div class="small-block brd-all">
          <span class="field-span">Valor {{ order.insurance_value | currency }}</span>
        </div>
      </div>
      <div class="row row-4-2">
        <div class="no-border small-block">
          <span class="field-span">Chave</span>
        </div>
        <div class="no-border small-block">
          <span class="field-span">Valor</span>
        </div>
      </div>
      <div class="row row-4-2">
        <div class="no-border small-block">
          <span class="field-span">{{ order.invoice && order.invoice.key }}</span>
        </div>
        <div class="no-border small-block">
          <span class="field-span">{{ order.insurance_value | currency }}</span>
        </div>
      </div>
    </div>

    <div class="block-1" style="padding-bottom: 10px;">
      <div class="row row-1 mb-8">
        <div class="small-block brd-all">
          <span class="field-span">OBSERVAÇÃO</span>
        </div>
      </div>
      <div class="row row-1">
        <div class="small-block brd-all space-block">
          <span
            class="field-span center-span"
          >Eu, em {{ moment().format('DD/MM/YYYY H:m:s') }} aceitei os termos de serviço definidos pela LATAM Cargo.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { ME_CNPJ, ME_NAME } from '../../config/cnpj';

  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    methods: {
      moment
    },

    static: {
      cnpj: ME_CNPJ,
      name: ME_NAME
    },

    computed: {
      minuta_code: function () {
        if (!this.order.tracking) {
          return '';
        }
        return String(this.order.tracking);
      },
      minuta_code_value: function () {
        if (!this.order.tracking) {
          return '';
        }
        return String(this.order.tracking).replace('LTM-', '');
      },
      origin: function () {
        if (!this.order.additional_info || !this.order.additional_info.from) {
          return {
            city: 'CITY',
            airport: 'AIRPORT'
          }
        }
        return {
          city: this.order.additional_info.from.city,
          airport: this.order.additional_info.from.airport
        }
      },
      destiny: function () {
        if (!this.order.additional_info || !this.order.additional_info.to) {
          return {
            city: 'CITY',
            airport: 'AIRPORT'
          }
        }
        return {
          city: this.order.additional_info.to.city,
          airport: this.order.additional_info.to.airport
        }
      },
      groupVolumes: function () {
       const volumesGroup = this.order.volumes.reduce((a, b) => {
         const i = a.findIndex(x => x.height === b.height && x.length === b.length && x.weight === b.weight && x.width === b.width);
         return i === -1 ? a.push({
           ...b,
           times: 1
         }) : a[i].times++, a;
       }, []);
       return volumesGroup;
      }
    },

    filters: {
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      upper(text) {
        return String(text || '').toUpperCase();
      }
    },

    created() {
      moment.locale('pt_br');
    },

    mounted() {
      BarCode('.barcode').init();
    }
  }
</script>

<style lang="stylus" scoped>
  @media print
    .minuta
      display block
      margin 0 auto
  .minuta
    margin 0 auto !important
    font-family Arial, 'Open Sans', sans-serif
    img
      height 110px
      justify-self center
      align-self center
  .barcode
    transform: scale(.7) !important
  .grid
    display grid
  .block-1-2
    display grid
    grid-template-columns 1fr 2fr
  .block-2
    display grid
    grid-template-columns 1fr 1fr
  .column
    display grid
  .large-block
    height 80px
    & > div
      padding 8px
      box-sizing border-box
  .big-block
    height 50px
  .medium-block
    height 40px
  .small-block
    height 33px
  .row
    display grid
  .row-1
    display grid
  .row-2
    grid-template-columns 1fr 1fr
  .row-2-1
    grid-template-columns 2fr 1fr
  .row-2-1-1
    grid-template-columns 2fr 1fr 1fr
  .row-3
    grid-template-columns 1fr 1fr 1fr
  .row-3-2
    grid-template-columns 3fr 2fr
  .row-3-1-1-2
    grid-template-columns 3fr 1fr 1fr 2fr
  .row-4-2
    grid-template-columns 4fr 2fr
  .mt-16
    margin-top 16px
  .mb-8
    margin-bottom 8px
  .no-border
    border none !important
  .brd-tl
    border-top 1px solid #000
    border-left 1px solid #000
  .brd-r
    border-right 1px solid #000
  .brd-b
    border-bottom 1px solid #000
  .brd-all
    border 1px solid #000

  .field-span
    margin-top 4px
    margin-left 4px
    font-size 12px
  .center-span
    align-self center
  .subtitle
    margin-top 16px
    margin-bottom 4px
    display block
    font-size 12px
  .small-span
    font-size 8px
  .center
    text-align center
    font-size 16px
  .field-selector
    display block
    margin 2px 25px 0
  .space-block
    padding-top 15px
</style>
